import { emptyNotificationsState } from 'features/notifications/ducks/state'
import {
  fetchUnreadNotificationsCounterRoutine,
  fetchUnseenNotificationsCounterRoutine,
  fetchAllNotificationsRoutine,
  markAllNotificationsAsReadRoutine,
  markAllNotificationsAsSeenRoutine, markNotificationAsReadRoutine
} from 'features/notifications/ducks/actions'

const READ_MUTATIONS = [
  markAllNotificationsAsReadRoutine.REQUEST,
  markAllNotificationsAsReadRoutine.SUCCESS,
  markNotificationAsReadRoutine.REQUEST,
  markNotificationAsReadRoutine.SUCCESS
]

const SEEN_MUTATIONS = [
  markAllNotificationsAsSeenRoutine.REQUEST,
  markAllNotificationsAsSeenRoutine.SUCCESS
]

const toCount = value => {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
}

const counterPayload = payload => (payload && typeof payload === 'object'
  ? { count: toCount(payload.count), seq: payload.seq ?? null }
  : { count: toCount(payload), seq: null })

export default (state = emptyNotificationsState, action) => {
  if (READ_MUTATIONS.includes(action.type)) {
    state = { ...state, counterMutationSeq: (state.counterMutationSeq || 0) + 1 }
  }
  if (SEEN_MUTATIONS.includes(action.type)) {
    state = { ...state, seenMutationSeq: (state.seenMutationSeq || 0) + 1 }
  }
  switch (action.type) {
    case fetchAllNotificationsRoutine.SUCCESS:
      return {
        ...state,
        all: action.payload,
        listLoaded: true
      }
    case fetchAllNotificationsRoutine.FAILURE:
      return {
        ...state,
        listLoaded: true
      }
    case fetchUnreadNotificationsCounterRoutine.SUCCESS: {
      const { count, seq } = counterPayload(action.payload)
      if (seq != null && seq !== (state.counterMutationSeq || 0)) return state
      return {
        ...state,
        unreadCounter: count
      }
    }
    case fetchUnseenNotificationsCounterRoutine.SUCCESS: {
      const { count, seq } = counterPayload(action.payload)
      if (seq != null && seq !== (state.seenMutationSeq || 0)) return state
      return {
        ...state,
        unseenCounter: count
      }
    }
    case markAllNotificationsAsSeenRoutine.SUCCESS:
      return {
        ...state,
        unseenCounter: 0
      }
    case markAllNotificationsAsReadRoutine.SUCCESS: {
      const readAt = new Date().toISOString()
      return {
        ...state,
        unreadCounter: 0,
        all: Array.isArray(state.all) ? state.all.map(n => (n.readAt ? n : { ...n, readAt })) : state.all
      }
    }
    case markNotificationAsReadRoutine.SUCCESS: {
      const id = action.payload
      const list = Array.isArray(state.all) ? state.all : []
      const item = list.find(n => n.id === id)
      if (item?.readAt) return state
      return {
        ...state,
        unreadCounter: Math.max(0, toCount(state.unreadCounter) - 1),
        all: item ? list.map(n => (n.id === id ? { ...n, readAt: new Date().toISOString() } : n)) : state.all
      }
    }
    default:
      return state
  }
}
